<script>
import { gqlClient } from "@root/apollo/apollo-options";
import { queryDistrict } from "@root/graphql/Root.gql";
import { resRest } from "@root/lib/utils";

const query = async (parentId = "root", tenantCode) => {
  let dataList = [];

  try {
    const res = await gqlClient.query({
      query: queryDistrict,
      variables: {
        input: {
          districtPcode: parentId,
          tenantCode
        },
        pageInput: {
          pageSize: 1000,
          pageNum: 1
        }
      }
    });

    dataList = resRest(res.data);
  } catch (err) {
    console.error(err);
  }

  return dataList;
};

export default {
  name: "RegionPicker",

  data() {
    return {};
  },

  props: {
    // orgCode
    tenantCode: {
      type: String,
      default: localStorage.getItem("tenantCode") || ""
    },

    value: {
      required: true
    },

    parentId: {
      required: false,
      default: "root"
    }
  },

  render(h) {
    return h("el-cascader", {
      // key: this.key,
      props: {
        // default options
        props: {
          lazy: true,
          lazyLoad: async (node, resolve) => {
            const { level } = node;

            query(node.value || this.parentId, this.tenantCode).then(data => {
              //
              resolve(
                data.map(item => {
                  if (
                    level === this.value.length - 1 &&
                    this.value[level] &&
                    item.value === this.value[level]
                  ) {
                    return {
                      ...item,
                      leaf: true
                    };
                  }

                  return item;
                })
              );
            });
          }
        },
        value: this.value,
        ...this.$attrs,
        // clearable 不可以被复写为 true
        clearable: false
      },
      on: {
        ...this.$listeners
      },
      ref: "picker"
    });
  },

  methods: {
    getCheckedNodes() {
      return this.$refs.picker.getCheckedNodes();
    },

    getCheckedComputedNodes() {
      return Array.from(this.$refs["picker"].getCheckedNodes())[0];
    }
  }
};
</script>
